// Leaderboard, IMG_4891/4892 (01.09.2026). Vergleicht alle freigeschalteten
// Nutzer der Instanz (Entscheidung mit Steffen, Antwort auf 15.6 in
// docs/decisions.md) statt nur hinzugefuegter Freunde wie im Original -
// das "+" zum Freunde-Hinzufuegen aus dem Screenshot entfaellt deshalb.
//
// "Nur Punkte" / "Kennzeichen" (IMG_4890, Einstellungen der Original-App)
// ist hier ein einfacher, nicht gespeicherter Client-Zustand.

import { useState } from "react";
import { Unterseite } from "../bausteine/Unterseite.js";
import { useLeaderboard } from "../lib/leaderboard.js";

export function Leaderboard() {
  const [anzeige, setAnzeige] = useState<"punkte" | "kennzeichen">("punkte");
  const { data } = useLeaderboard();
  const rangliste = [...(data ?? [])].sort((a, b) => b[anzeige] - a[anzeige]);

  return (
    <Unterseite
      titel="Leaderboard"
      kinder={
        <>
          <div className="mb-2 flex justify-end">
            <div className="flex rounded bg-neutral-100 p-1 text-sm font-medium">
              <button
                type="button"
                onClick={() => setAnzeige("punkte")}
                className={`rounded px-3 py-1 ${anzeige === "punkte" ? "bg-flaeche-inhalt text-akzent shadow-sm" : "text-neutral-500"}`}
              >
                Nur Punkte
              </button>
              <button
                type="button"
                onClick={() => setAnzeige("kennzeichen")}
                className={`rounded px-3 py-1 ${anzeige === "kennzeichen" ? "bg-flaeche-inhalt text-akzent shadow-sm" : "text-neutral-500"}`}
              >
                Kennzeichen
              </button>
            </div>
          </div>

          <div className="rounded bg-flaeche-inhalt shadow-sm">
            <div className="flex justify-end border-b border-neutral-100 px-4 py-2 text-sm text-neutral-500">
              {anzeige === "punkte" ? "Punkte" : "Kennzeichen"}
            </div>
            {rangliste.map((rang) => (
              <div
                key={rang.userId}
                className="flex items-center justify-between border-t border-neutral-100 px-4 py-3 text-sm first:border-t-0"
              >
                <span className="font-medium">{rang.displayName}</span>
                <span>{rang[anzeige]}</span>
              </div>
            ))}
            {rangliste.length === 0 && (
              <p className="px-4 py-6 text-center text-sm text-neutral-500">Noch niemand hat etwas gesammelt.</p>
            )}
          </div>
        </>
      }
    />
  );
}
